<template>
  <div class="container mt-5 mb-5">
    <h2>Admin Dashboard</h2>
    <div class="row">
      <div class="col-md-1">
        <nav class="nav flex-column">
          <router-link :to="{ name: 'AdminProjectList' }" class="nav-link">Progetti</router-link>
        <router-link :to="{ name: 'AdminUserDashboard'}" class="nav-link">Utenti</router-link>
        </nav>
      </div>
      <div class="col-md-11">
        <router-view/>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AdminDashboard',
  data() {
    return {}
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/AdminDashboard.vue